SingleProduct.directive( 'toggleDefColor', [ 'VariationsSrv', function( VariationsSrv ) {
	return {
		restrict: 'A',
		link: function( scope, element ) {
			element.on('change', function () {
				VariationsSrv.toggleDefColor( element.is(':checked'), this.value )
				scope.variations.boxSizes = VariationsSrv.getBoxSizes();

			})
		}
	}
}])